import CircularLoading from "components/CircularLoading";
import ROUTES from "constants/routes";
import { UserContext } from "context/userContext";
import { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import UserLogin from "./UserLogin";

const Login = () => {
  const location = useLocation();
  const { me, meError, meLoading } = useContext(UserContext);

  if (meLoading) return <CircularLoading />;

  if (!me || meError) {
    return <UserLogin />;
  }

  return (
    <Navigate
      to={`/${ROUTES.SELECT_COMPANY}${location.search}`}
      replace
    />
  );
};

export default Login;
